import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ModelService {

  public settings: any;
  public view: any;

  constructor() { }

  setEmptySettings() {
    this.settings = {
      contractKind: {
        durationsValues: [],
        mileageValues: []
      }
    };
  }
}
